<template>
  <div>
    <div v-if="hasNotFoundProducts" class="not-found-body">
      <div class="summary-not-found-items">
        <h3 class="summery-not-found-items-header-title">
          <warning-circle class="warning-icon"></warning-circle>
          {{ $t('OrderPopupBodySuccess.not_found_products_warning') }}
        </h3>
        <div v-for="(option, key) in notFoundProductSummary" :key="key">
          <span class="label" v-text="key"></span>
          <div class="product" v-for="product in option">
            <span class="amount" v-text="product.amount"></span>
            <span class="sub-label" v-text="product.name"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="order-body">
      <div class="summary-items">
        <emat-order-summary
            :name="$t('OrderPopupBodySuccess.your_charging_station')"
            :options="orderSummary"
            :products="productSummary"
            :type="type"
            :footer="false"
            :order="true"
        ></emat-order-summary>
      </div>
      <div class="additional-info">
        <span class="label">{{ $t('OrderPopupBodySuccess.warranty_guarantee', { type: type.name }) }}</span>
        <span class="sub-label">{{ $t('OrderPopupBodySuccess.warranty') }}</span>

        <div class="price-wrapper">
         <span class="label">
              {{ $t('global.word.price') }}
           </span>
          <span class="sub-label">{{ orderAmount }}x {{ formatPrice((price - totalProductPrice).toFixed(2)) }}/s</span>

          <div class="total-price">
            <span class="price">{{ formatPrice(totalPrice) }}</span>
            <span class="btw">{{ formatPrice(totalBtw) }} incl. BTW</span>
          </div>
        </div>
      </div>

      <div class="image-wrapper" v-if="!isMobile">
        <charging-station-image :is-order="true" v-if="type && type.type === 'laadpaal'"></charging-station-image>
        <charging-pillar-image :is-order="true" v-else></charging-pillar-image>
        <div class="shadow-img">
          <ShadowSvg />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EmatOrderSummary from 'Components/Layout/OrderSummary';
import ChargingStationImage from '@/components/configuration/image/ChargingStationImage';
import ChargingPillarImage from '@/components/configuration/image/ChargingPillarImage';
import ShadowSvg from '../../assets/images/shadow.svg?inline';
import WarningCircle from '../../assets/images/icons/warning-circle.svg?inline'

export default {
  name: 'OrderPopupBodySuccess',

  components: {
    ChargingPillarImage,
    ChargingStationImage,
    EmatOrderSummary,
    ShadowSvg,
    WarningCircle,
  },

  props: {
    price: String,
    btw: String,
  },

  computed: {
    ...mapGetters({
      orderSummary: 'build/getConfigurationSummary',
      productSummary: 'products/getProductSummary',
      type: 'types/current',
      extraWishes: 'build/getWishes',
      products: 'products/getAll',
      device: 'getDevice',
      notFoundProductSkus: 'order/getNotFoundProductSkus'
    }),

    notFoundProductSummary() {
      const notFoundProducts = {};
      Object.entries(this.productSummary).forEach(([key, products]) => {
        const filteredProducts = products.filter((product) => product.notFound);
        if (filteredProducts.length) {
          notFoundProducts[key] = filteredProducts;
        }
      });

      return notFoundProducts;
    },

    hasNotFoundProducts() {
      return !!this.notFoundProductSkus.length;
    },

    orderAmount: {
      get() {
        return this.$store.getters['order/getOrderAmount'];
      },
      set(value) {
        this.$store.dispatch('order/changeOrderAmount', value);
      },
    },

    isMobile() {
      return this.device === 'mobile';
    },
    totalPrice() {
      return ((this.orderAmount * this.price) - this.notFoundProductsPrice).toFixed(2);
    },
    totalBtw() {
      return ((this.orderAmount * this.btw) - (this.notFoundProductsPrice * 1.21)).toFixed(2);
    },
    totalProductPrice() {
      return this.products.reduce((total, product) => {
        return total + (product.price * product.amount);
      }, 0);
    },
    notFoundProductsPrice() {
      return this.products
        .filter((product) => this.notFoundProductSkus.includes(product.sku))
        .reduce((total, product) => {
          return total + (product.price * product.amount);
        }, 0);
    }
  },

  methods: {
    hasProducts(products) {
      return Object.keys(products).every(function(key) {
        return products[key].amount === 0;
      });
    },
    formatPrice(price) {
      return price.replace('.', ',');
    },
  },
};
</script>

<style scoped lang="scss">
.not-found-body {
  display: flex;
  padding: 15px;
  background-color: $background-color;

  .summary-not-found-items {
    .summery-not-found-items-header-title {
      font-family: $font-heading-bold;
      display: block;
      font-size: 18px;
      color: $primary;
    }

    .label {
      color: #196CAE;
      font-size: 12px;
      font-weight: $font-weight-bold;
    }

    .product {
      line-height: 16px;
      color: rgba(0, 0, 0, .5);
      display: flex;
      font-size: 12px;

      .amount {
        font-family: $font-heading-bold;
        border-right: 1px solid #e9e9e9;
        margin-right: 5px;
        color: #196cae;
        width: 15px;
        min-width: 15px;
        text-align: center;
        display: block;
      }

      .sub-label {
        color: #000;
        font-weight: $font-weight-thin;
        padding-left: 5px;
      }
    }
  }
}
.order-body {
  display: flex;
  padding: 15px 15px 30px 15px;
  background-color: $background-color;

  .summary-items {
    margin-right: 100px;
    max-width: 162px;

    @media only screen and (max-width: 576px) {
      margin-right: 50px;
    }
  }

  .additional-info {
    display: flex;
    flex-direction: column;

    .price-wrapper {
      display: flex;
      flex-direction: column;
      margin-top: 30px;

      .total-price {
        display: flex;
        flex-direction: column;
        font-family: $font-heading-bold;
        font-size: 22px;
        color: $primary;
        margin-top: 6px;
      }

      .btw {
        font-family: $font;
        font-size: 12px;
        color: #000;
      }
    }

    .label {
      color: #196CAE;
      font-size: 12px;
      font-family: $font-black;
    }

    .sub-label {
      color: #000;
      font-size: 12px;
      font-family: $font;
    }
  }

  .image-wrapper {
    max-width: 100px;
    max-height: 144px;
    position: relative;
    margin-left: auto;

    .image-container {
      padding: 0;
    }

    .shadow {
      position: relative;
      top: -8px;
    }
  }

  .half {
    &.left {
      width: 30%;
    }

    .label {
      color: rgba(0, 0, 0, 0.5);
      font-family: AntennaCond, sans-serif;
      font-weight: 700;
      font-size: 14px;
    }

    &.right {

      p {
        margin: 0;
        color: rgba(0, 0, 0, 0.5);
        font-family: 'Antenna', sans-serif;
        font-size: 12px;
      }

      .warranty {
        padding: 15px 0;
        display: flex;
        align-items: center;


        img {
          width: 50px;
          height: 28px;
        }

        span {
          padding-left: 20px;
          display: block;
          font-family: AntennaCond, sans-serif;
          font-weight: 900;
          font-size: 14px;
          max-width: 80px;
          text-align: center;
        }
      }

      .title {
        display: block;
        margin-top: 10px;
        font-family: 'Antenna', sans-serif;
        font-weight: 900;
        font-size: 12px;
      }

      .order-total {
        display: flex;
        width: auto;
        justify-content: space-between;

        .label {
          display: flex;
          flex-direction: column;
          font-size: 14px;
          font-family: AntennaCond, sans-serif;
          font-weight: 700;

          .price {
            color: #196CAE;
            font-family: AntennaCond, sans-serif;
            font-weight: 700;

            &.total {
              font-size: 22px;
              font-weight: 700;
            }
          }

          .btw {
            color: #000000;
            font-family: Antenna, sans-serif;
            font-weight: 400;
            font-size: 12px;
          }
        }
      }

      .product-total {
        display: flex;
        width: auto;
        flex-wrap: wrap;

        .product-header {
          display: flex;
          flex-direction: row;
          width: 100%;
          justify-content: space-between;

          .label:first-child {
            width: 160px;
          }
        }

        .product {
          display: flex;
          width: 100%;
          flex-direction: row;
          justify-content: space-between;
          font-size: 12px;
          position: relative;
          margin: 5px 0;

          .name {
            max-width: 200px;
          }

          .amount {
            position: absolute;
            top: 0;
            left: 70%;
            color: #196CAE;
            font-family: Antenna, sans-serif;
            font-weight: 700;
          }

          .price {
            color: #196CAE;
            font-family: Antenna, sans-serif;
            font-weight: 700;
            margin-left: auto;
          }
        }
      }

      .product-total-price {
        margin: 5px 0 0 auto;
        display: flex;
        flex-direction: column;
        width: auto;

        .label {
          text-align: end;
        }

        .price {
          color: #196CAE;
          font-family: Antenna, sans-serif;
          font-weight: 700;

          &.total {
            font-size: 16px;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
